<template>
    <a-layout id="install">
        <a-spin v-if="loading"></a-spin>
        <a-layout-content class="install_content" v-if="!loading">
            <div class="install_logo">
                <ul>
                    <li><img src="/static/img/logo2.png" /></li>
                    <li>
                        <icon-font type="icon-qiyeweixinfuwushang2" class="logo_icon" />
                    </li>
                </ul>
            </div>
            <div class="box_wrapper">
                <div class="install_box" :class="position ? 'position' : ''">
                    <a-row type="flex" justify="center" align="middle" :gutter="240" class="row">
                        <a-col :span="12" class="col">
                            <icon-font type="icon-qiyeweixin1" class="col_icon" />
                            <h1>还没有企业微信</h1>
                            <p>3分钟立即注册带有机汇管家的企业微信</p>
                            <a-button type="primary" size="large" block @click="toRegister">
                                <icon-font
                                    type="icon-xingzhuang"
                                    :style="{ fontSize: '18px', transform: 'translateY(3px)' }"
                                />
                                注册企业微信
                            </a-button>
                        </a-col>
                        <a-col :span="12" class="col">
                            <icon-font type="icon-jihuiguanjia" class="col_icon" />
                            <h1>已有企业微信</h1>
                            <p>30秒安装机汇管家到企业微信</p>
                            <a-button size="large" block @click="toInstall" class="btn_install">
                                <icon-font
                                    type="icon-xingzhuang"
                                    :style="{ fontSize: '18px', transform: 'translateY(3px)' }"
                                />
                                安装到企业微信
                            </a-button>
                            <span class="col_login">
                                已经安装，
                                <router-link :to="{ path: 'login' }">点击登录</router-link>
                            </span>
                        </a-col>
                    </a-row>
                </div>
            </div>
        </a-layout-content>
        <a-layout-footer class="install_footer" v-if="!loading">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                浙ICP备14038176号-11
            </a>
        </a-layout-footer>
        <a-modal v-model="visible" title="注册企业微信">
            <p>{{ registerText }}</p>
            <template slot="footer">
                <a-space v-if="isJump">
                    <a-button @click="toJump">重新注册</a-button>
                    <a-button type="primary" @click="toCheck">完成注册</a-button>
                </a-space>
                <a-space v-else>
                    <a-button @click="toCancel">取消</a-button>
                    <a-button type="primary" @click="toJump">继续</a-button>
                </a-space>
            </template>
        </a-modal>
    </a-layout>
</template>

<script>
import api from '@/apis';
import dayjs from 'dayjs';
import iconFont from '/public/commom.js';
export default {
    components: {
        iconFont
    },
    data() {
        return {
            loading: false,
            visible: false,
            isJump: false,
            position: true,
            screenHeight: 0,
            defaultUrl: process.env.VUE_APP_DEFAULT,
            registerText: '',
            registerCode: ''
        };
    },
    watch: {
        screenHeight(val) {
            this.position = val > 0 ? true : false;
        }
    },
    mounted() {
        this.screenHeight = document.documentElement.clientHeight / 2 - 450;
        window.onresize = () => {
            this.screenHeight = document.documentElement.clientHeight / 2 - 450;
        };
        if (this.$route.query && this.$route.query.auth_code) {
            this.loading = true;
            this.toLogin();
        }
    },
    methods: {
        async toInstall() {
            try {
                const res = await api.postAuthUrl({ url: `${this.defaultUrl}/install` });
                if (res.code !== 0) return;
                const resp = await api.postAuthSession({ code: res.preAuthCode, authType: 1 });
                if (resp.code !== 0) return;
                window.location.href = res.url;
            } catch (err) {
                console.log(err);
            }
        },
        async toLogin() {
            try {
                const res = await api.postAuthCode({
                    code: this.$route.query.auth_code,
                    state: this.$route.query.state
                });
                if (res.code !== 0) return;
                this.$router.push({ path: '/login' });
            } catch (err) {
                console.log(err);
            }
        },
        async toRegister() {
            try {
                const res = await api.postRegisterCode();
                if (res.code !== 0) return;
                this.registerCode = res.registerCode;
                window.sessionStorage.setItem(
                    'expiresIn',
                    JSON.stringify({ expiresIn: res.expiresIn, date: dayjs().unix() })
                );
                this.registerText =
                    '点击「继续」后将为你打开新网页进行企业微信注册，务必在完成注册后手动回到本页面进行后续操作';
                this.visible = true;
            } catch (err) {
                console.log(err);
            }
        },
        toJump() {
            const { expiresIn, date } = JSON.parse(window.sessionStorage.getItem('expiresIn'));
            if (dayjs().unix() - parseInt(date) > parseInt(expiresIn)) {
                window.sessionStorage.removeItem('expiresIn');
                this.registerCode = '';
                this.$message.error('注册码已过期，请重新注册');
                this.visible = false;
                return;
            }
            window.open(
                `https://open.work.weixin.qq.com/3rdservice/wework/register?register_code=${this.registerCode}`
            );
            this.isJump = true;
            this.registerText = '点击「完成注册」后，进入机汇管家登录页面，可登录进入机汇管家后台';
        },
        toCheck() {
            this.$router.push({ path: '/login' });
        },
        toCancel() {
            this.visible = false;
            this.isJump = false;
            this.registerText = '';
        }
    }
};
</script>

<style scoped>
#install {
    width: 100%;
    height: 100vh;
    background: #eee;
    display: flex;
    align-items: center;
    justify-content: center;
}
#install .install_content {
    width: 72vw;
    min-width: 800px;
    height: 100vh;
    margin: 0 auto;
}
#install .install_content .install_logo {
    padding: 34px 0 30px 0;
    position: relative;
}
#install .install_content .install_logo ul {
    font-size: 0;
    margin: 0 -15px;
}
#install .install_content .install_logo ul li {
    display: inline-block;
    vertical-align: middle;
    padding: 0 15px;
    position: relative;
}
#install .install_content .install_logo ul li:first-child::after {
    content: '';
    display: block;
    width: 1px;
    height: 16px;
    background: #dbdbdb;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
}
#install .install_content .install_logo ul li img {
    display: block;
    height: 26px;
}
#install .install_content .install_logo ul li .logo_icon {
    font-size: 156px;
    position: absolute;
    top: 0;
    right: -131px;
    transform: translateY(-50%);
}
#install .install_content .box_wrapper {
    width: 100%;
    height: calc(100vh - 90px);
    position: relative;
    /* display: flex;
    align-items: center;
    justify-content: center; */
}
#install .install_content .install_box {
    width: 100%;
    min-width: 800px;
    height: 75%;
    min-height: 520px;
    max-height: 606px;
    background: #fff;
    flex: unset;
    padding: 50px 120px;
    box-sizing: border-box;
    position: absolute;
    text-align: center;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
}
#install .install_content .install_box.position {
    top: calc(50vh - 450px);
}
#install .install_content .install_box:after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 1px;
    height: 100%;
    background: #f5f5f5;
}
#install .install_content .install_box .row {
    height: 100%;
}
#install .install_content .install_box .col {
    position: relative;
}
#install .install_content .install_box .col_icon {
    font-size: 80px;
    border: 1px solid #e6e6e6;
    border-radius: 20px;
    padding: 4px;
    margin-bottom: 4px;
}
#install .install_content .install_box h1 {
    font-size: 24px;
    line-height: 1;
    font-weight: 400;
    margin: 20px 0;
}
#install .install_content .install_box p {
    font-size: 12px;
    line-height: 1.4;
    margin-bottom: 36px;
}
#install .install_content .install_box .btn_install.ant-btn {
    color: #ff7b29;
    background-color: #fff;
    border-color: #ff7b29;
}
#install .install_content .install_box .col_login {
    position: absolute;
    bottom: -52px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}
#install .install_footer {
    background: none;
    padding: 30px;
    z-index: 2;
    position: relative;
}
#install .install_footer a {
    color: #ccc;
}
</style>
